module.exports = __webpack_public_path__ + "img/about.ff2a1edf.jpeg";